import MDBox from "../../../Components/MDBox";
import {useFormik} from "formik";
import {
    AccordionActions,
    AccordionDetails,
    AccordionSummary,
    ButtonBase,
    Grid,
    TableBody,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import MDTypography from "../../../Components/MDTypography";
import {setLoading, useMaterialUIController} from "../../../Context/mui";
import React, {useLayoutEffect, useState} from "react";
import MDDate from "../../../Components/MDDate";
import MDInput from "../../../Components/MDInput";
import MDSelect from "../../../Components/MDSelect";
import * as yup from "yup";
import {UserModel} from "../../../Api/Model/UserModel";
import Cookies from "js-cookie";
import {ErrorToaast, SuccessToaast} from "../../../utils/toast/Toast";
import {useNavigate, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import {CurrentUser} from "../../../utils/Hooks/currentUser";
import Paper from "@mui/material/Paper";
import {Accordion, Table} from "reactstrap";
import MDTableCell from "../../../Components/MDTable/MDTableCell";
import HeroLayout from "../../../Components/LayoutContainers/HeroLayout";

import SILF from "../../../Asset/images/SILF.png";
import SILM from "../../../Asset/images/SILM.png";
import MasdImage from "../../../Asset/images/masd.png";
import FasdImage from "../../../Asset/images/fasd.png";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";


const steps = [
    0, 1, 2, 3, 4, 5
];
const getValidationSchema = (role) => {
    let general = yup.object({
        name: yup.string().required("نام الزامی است"),
        lastName: yup.string().required("نام خانوادگی الزامی است"),
        sex: yup.string().required("جنسیت الزامی است"),
        Birthday: yup.date().required("تاریخ تولد الزامی است"),
        CodeMeli: yup.string().required("کد ملی الزامی است"),

    })
    let Pezeshk = yup.object({
        Takhasos: yup.string().required("تخصص الزامی است"),

    })
    let ParentSudent = yup.object({
        BirthCity: yup.string().required("محل تولد الزامی است"),
        FatherName: yup.string().required("نام پدر الزامی است"),
        PhoneNumber: yup.string().required("شماره تلفن الزامی است"),
        SathTahsilat: yup.string().required("سطح تحصیلات الزامی است"),
        MaghTahsilat: yup.string().required("مقطع تحصیلات الزامی است"),

    })
    let Morabi = yup.object({
        ReshteTahsili: yup.string().required("رشته تحصیلی الزامی است"),
        SabgheShoghli: yup.string().required("سابقه شغلی الزامی است"),

    })
    let others = yup.object({
        NoeBime: yup.string().required("نوع بیمه الزامی است"),
        Boomi: yup.string().required("وضعیت بومی الزامی است"),
        MotherName: yup.string().required("نام مادر الزامی است"),
        MotherJob: yup.string().required("شغل مادر الزامی است"),
        FatherJob: yup.string().required("شغل پدر الزامی است"),
        ParentStatus: yup.string().required("وضعیت زندگی والدین الزامی است"),
        Mazhab: yup.string().required("مذهب الزامی است"),
        NoeSchoole: yup.string().required("نوع مدرسه الزامی است"),
        PayeThsili: yup.string().required("پایه تحصیلی الزامی است"),
        CityTahsil: yup.string().required("شهر محل تحصیل الزامی است"),
        TaradodMadrse: yup.string().required("وضعیت تردد به مدرسه الزامی است"),
        DateSchool: yup.date().required("تاریخ ورود به مدرسه الزامی است"),
        ShomSkoonat: yup.string().required("شماره محل سکونت الزامی است"),
        AddressSkoonat: yup.string().required("آدرس محل سکونت الزامی است"),
    })
    let all = general;
    if (role === "Pezeshk") {
        all = all.concat(Pezeshk)
    }
    if (role === "Morabi") {
        all = all.concat(Morabi)
    }
    if (role === "Student") {
        all = all.concat(others)
    }
    if (role === "Parent") {
        all = all.concat(ParentSudent)
    }

    return all
};
export default function StudentPersonal() {
    const [activeStep, setActiveStep] = React.useState(0);

    const [controller, dispatch] = useMaterialUIController();
    const [isNew, setIsnew] = useState(true)
    const [bmiWarn, setIsBmiWarn] = useState(false)

    const [studentShowMedalDialog, setStudentShowMedalDialog] = useState({open: false, model: null});
    const navigate = useNavigate();
    const {loading} = controller;

    var Api = new UserModel(Cookies.get("cst") ?? "");

    const formik = useFormik({
        initialValues: {
            name: "",
            lastName: "",
            NoeBime: "",
            sex: "",
            Birthday: "",
            BirthCity: "",
            Boomi: "",
            PhoneNumber: "",
            FatherName: "",
            MotherName: "",
            MotherJob: "",
            FatherJob: "",
            ParentStatus: "",
            Mazhab: "",
            CodeMeli: "",
            NoeSchoole: "",
            PayeThsili: "",
            CityTahsil: "",
            TaradodMadrse: "",
            Takhasos: "",
            ReshteTahsili: "",
            SathTahsilat: "",
            MaghTahsilat: "",
            SabgheShoghli: "",
            DateSchool: "",
            ShomSkoonat: "",
            AddressSkoonat: ""
        },
        onSubmit: (values) => {
            setLoading(dispatch, true);
            Api.UpdateInformation({
                name: values.name,
                lastName: values.lastName,
                NoeBime: values.NoeBime,
                sex: values.sex?.toString(),
                Birthday: values.Birthday,
                BirthCity: values.BirthCity,
                Boomi: values.Boomi?.toString(),
                PhoneNumber: values.PhoneNumber.toString(),
                FatherName: values.FatherName,
                MotherName: values.MotherName,
                MotherJob: values.MotherJob,
                FatherJob: values.FatherJob,
                Takhasos: values.Takhasos,
                ReshteTahsili: values.ReshteTahsili,
                SathTahsilat: values.SathTahsilat,
                MaghTahsilat: values.MaghTahsilat,
                SabgheShoghli: values.SabgheShoghli,
                ParentStatus: values.ParentStatus?.toString(),
                Mazhab: values.Mazhab,
                CodeMeli: values.CodeMeli,
                NoeSchoole: values.NoeSchoole,
                PayeThsili: values.PayeThsili,
                CityTahsil: values.CityTahsil,
                TaradodMadrse: values.TaradodMadrse,
                DateSchool: values.DateSchool,
                ShomSkoonat: values.ShomSkoonat.toString(),
                AddressSkoonat: values.AddressSkoonat
            })
                .then(response => {
                    setLoading(dispatch, false)
                    handleChangeMStep()

                    SuccessToaast("با موفقیت ویرایش شد")
                })
                .catch(error => {
                    ErrorToaast("خطا در ثبت اطلاعات");
                    setLoading(dispatch, false);
                });
        },

        validationSchema: getValidationSchema(CurrentUser()?.Role)
    })
    useLayoutEffect(() => {

        setLoading(dispatch, true)
        Api.Information()
            .then(r => {
                if (r.data.data !== null) {
                    setIsnew(false)
                    let model = r.data.data;
                    formik.setValues({
                        name: model.name,
                        lastName: model.lastName,
                        NoeBime: model.noeBime,
                        sex: model.sex,
                        Birthday: model.birthday,
                        BirthCity: model.birthCity,
                        Boomi: model.boomi,
                        PhoneNumber: model.phoneNumber,
                        Takhasos: model.takhasos,
                        ReshteTahsili: model.reshteTahsili,
                        SathTahsilat: model.sathTahsilat,
                        MaghTahsilat: model.maghTahsilat,
                        SabgheShoghli: model.sabgheShoghli,
                        FatherName: model.fatherName,
                        MotherName: model.motherName,
                        MotherJob: model.motherJob,
                        FatherJob: model.fatherJob,
                        ParentStatus: model.parentStatus,
                        Mazhab: model.mazhab,
                        CodeMeli: model.codeMeli,
                        NoeSchoole: model.noeSchoole,
                        PayeThsili: model.payeThsili,
                        CityTahsil: model.cityTahsil,
                        TaradodMadrse: model.taradodMadrse,
                        DateSchool: model.dateSchool,
                        ShomSkoonat: model.shomSkoonat,
                        AddressSkoonat: model.addressSkoonat

                    })
                    setIsBmiWarn(model?.isBmi);

                }
                setLoading(dispatch, false)
            })
            .then(() => {
                Api
                    .GetMedal(CurrentUser()?.user.id)
                    .then((r) => {
                        setStudentShowMedalDialog({model: r.data.data, open: true})
                    })
                    .catch(() => {
                        ErrorToaast("خطا در دریافت اطلاعات")
                    });
            })
            .catch(r => {

                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })

    }, [])
    const totalSteps = () => {
        return steps.length;
    };
    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const handleNext = () => {
        setActiveStep(newActiveStep);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleStep = (step) => () => {
        setActiveStep(step);

    };

    function handleNextStep() {
        if (activeStep === 5) {
            formik.handleSubmit()

        } else {
            setActiveStep(c => c + 1)
        }
    }

    function handleChangeMStep() {
        if (activeStep === 6) {
            setActiveStep(null)
            navigate("/studentlanding", {replace: true})
            return;
        }

        setActiveStep(c => c + 1)


    }

    function handleBazgasht() {
        navigate("/studentlanding", {replace: true})
    }

    return <HeroLayout Showdesc={![6].includes(activeStep)}>

        {/*{bmiWarn && (*/}
        {/*    <MDBox py={3} bgColor="#ffdbdb" border={"1px solid red"} p={1} mb={2} flex={1} borderRadius={2}*/}
        {/*           style={{overflowX: "auto", borderRadius: "10px"}}>*/}
        {/*        <MDTypography fontWeight={"bold"} sx={{color: "darkblue"}}>*/}
        {/*            شما اخطار BMI دارید لطفا با پزشک خود در ارتباط  باشید*/}
        {/*        </MDTypography>*/}
        {/*    </MDBox>)*/}
        {/*}*/}
 
        {![6].includes(activeStep) ? <>
            <MDBox mx={{xs: 2, md: 10, xl: 10}} mt={4} component="form" role="form" onSubmit={formik.handleSubmit}>
                <MDBox sx={{justifySelf: "center"}}>
                    <img src={CurrentUser().user.Sex === "F" ? SILF : SILM} style={{height: "15vh"}}/>
                </MDBox>
            </MDBox>
            <MDBox py={3} p={2} mb={2} flex={1} borderRadius={2} style={{overflowX: "auto"}}>
                <Grid container justifyContent={"center"} wrap="nowrap">

                    <Grid container>
                        {studentShowMedalDialog?.model && (
                            <Grid item xs={12} mb={3}>
                                <MDBox p={2} sx={{ background: "#4caf50", color: "white", borderRadius: "10px", textAlign: "center", boxShadow: 3 }}>
                                    <MDTypography variant="h5" color="white" fontWeight="bold">
                                        مجموع امتیازات شما: {
                                            (() => {
                                                let total = 0;
                                                studentShowMedalDialog.model.forEach(group => {
                                                    group.medals.forEach(medal => {
                                                        if (medal.medalType === 0) total += 10;
                                                        else if (medal.medalType === 1) total += 5;
                                                        else if (medal.medalType === 2) total += 2;
                                                        else if (medal.medalType === 3) total += 20;
                                                    });
                                                });
                                                return total;
                                            })()
                                        } امتیاز
                                    </MDTypography>
                                </MDBox>
                            </Grid>
                        )}
                        {studentShowMedalDialog?.model?.map((group, index) => (
                            <Grid item container key={index} spacing={2} mb={1}>
                                <Grid item xs={12}>
                                    <MDTypography variant="h6">{group.title}</MDTypography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer component={Paper} style={{background: "#2D79DD", color: "white"}}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <MDTableCell>نوع مدال</MDTableCell>
                                                    <MDTableCell>تاریخ اهدا</MDTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {group.medals.map((medal, idx) => (
                                                    <TableRow key={idx}>
                                                        <MDTableCell style={{background: "#2D79DD", color: "white"}}>
                                                            {medal.medalType === 0 && "طلا"}
                                                            {medal.medalType === 0 && (<img height={30} width={30}
                                                                                            src={require('../../../Asset/images/medal1.png')}/>)}
                                                            {medal.medalType === 1 && "نقره"}
                                                            {medal.medalType === 1 && (<img height={30} width={30}
                                                                                            src={require('../../../Asset/images/medal2.png')}/>)}
                                                            {medal.medalType === 2 && "برنز"}
                                                            {medal.medalType === 2 && (<img height={30} width={30}
                                                                                            src={require('../../../Asset/images/medal3.png')}/>)}
                                                            {medal.medalType === 3 && "ویژه"}
                                                            {medal.medalType === 3 && (<img height={30} width={30}
                                                                                            src={require('../../../Asset/images/medal4.png')}/>)}
                                                        </MDTableCell>
                                                        <MDTableCell style={{background: "#2D79DD", color: "white"}}>
                                                            {new Date(medal.modified).toLocaleString('fa-IR')}
                                                        </MDTableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </MDBox>
            <MDBox sx={{
                width: {xs: "100%", md: "100%", xl: "50%"},
                minHeight: "50vh",
                justifySelf: "center",
                background: "white",
                border: "1px solid #00000073",
                borderRadius: "10px",
                px: {xs: 1, md: 1, xl: 10},
                py: 5
            }}>
                <Grid container spacing={10}>
                    {activeStep === 0 && <>
                        <Grid item xs={12}>
                            <MDInput
                                id="name"
                                name="name"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.name)
                                }
                                helperText={formik.errors.name}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"نام"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="lastName"
                                name="lastName"
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.lastName)
                                }
                                helperText={formik.errors.lastName}
                                autoComplete={"1"}
                                disabled={loading}
                                // width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"نام خانوادگی"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDSelect
                                id="sex"
                                name="sex"
                                value={formik.values.sex}
                                onChange={(r) => formik.setFieldValue("sex", r)}
                                error={
                                    Boolean(formik.errors.sex)
                                }
                                helperText={formik.errors.sex}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"جنسیت"}>
                                <option value={"زن"}>زن</option>
                                <option value={"مرد"}>مرد</option>


                            </MDSelect>
                        </Grid>
                    </>}
                    {activeStep === 1 && <>
                        <Grid item xs={12}>
                            <MDDate
                                name="Birthday"
                                onChange={(r) =>
                                    formik.setFieldValue("Birthday", r)
                                }
                                defaultValue={formik.values.Birthday}
                                label={("تاریخ تولد")}
                                error={
                                    Boolean(formik.errors.Birthday)
                                }
                                portal
                                helperText={
                                    formik.errors.Birthday
                                }
                                w={{xs: "100%", md: "100%", lg: "100%",}}

                                disabled={loading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="BirthCity"
                                name="BirthCity"
                                value={formik.values.BirthCity}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.BirthCity)
                                }
                                helperText={formik.errors.BirthCity}
                                autoComplete={"1"}
                                disabled={loading}
                                // width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"محل تولد"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="PhoneNumber"
                                name="PhoneNumber"
                                type={"number"}

                                value={formik.values.PhoneNumber}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.PhoneNumber)
                                }
                                helperText={formik.errors.PhoneNumber}
                                autoComplete={"1"}
                                disabled={loading}
                                // width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"شماره تلفن"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDSelect
                                id="Boomi"
                                name="Boomi"
                                value={formik.values.Boomi}
                                onChange={(r) => formik.setFieldValue("Boomi", r)}
                                error={
                                    Boolean(formik.errors.Boomi)
                                }
                                helperText={formik.errors.Boomi}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"وضعیت بومی"}>
                                <option value={"بومی"}>بومی</option>
                                <option value={"غیر بومی"}>غیر بومی</option>


                            </MDSelect>
                        </Grid>
                    </>}
                    {activeStep === 2 && <>
                        <Grid item xs={12}>
                            <MDInput
                                id="FatherName"
                                name="FatherName"
                                value={formik.values.FatherName}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.FatherName)
                                }
                                helperText={formik.errors.FatherName}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"نام پدر"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="FatherJob"
                                name="FatherJob"
                                value={formik.values.FatherJob}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.FatherJob)
                                }
                                helperText={formik.errors.FatherJob}
                                autoComplete={"1"}
                                disabled={loading}
                                // width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"شغل پدر"}/>
                        </Grid>

                        <Grid item xs={12}>
                            <MDInput
                                id="MotherName"
                                name="MotherName"
                                value={formik.values.MotherName}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.MotherName)
                                }
                                helperText={formik.errors.MotherName}
                                autoComplete={"1"}
                                disabled={loading}
                                // width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"نام مادر"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="MotherJob"
                                name="MotherJob"
                                value={formik.values.MotherJob}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.MotherJob)
                                }
                                helperText={formik.errors.MotherJob}
                                autoComplete={"1"}
                                disabled={loading}
                                // width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"شغل مادر"}/>
                        </Grid>
                    </>}
                    {activeStep === 3 && <>
                        <Grid item xs={12}>
                            <MDInput
                                id="Mazhab"
                                name="Mazhab"
                                value={formik.values.Mazhab}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.Mazhab)
                                }
                                helperText={formik.errors.Mazhab}
                                autoComplete={"1"}
                                disabled={loading}
                                // width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"مذهب"}/>
                        </Grid>

                        <Grid item xs={12}>
                            <MDSelect
                                id="NoeSchoole"
                                name="NoeSchoole"
                                value={formik.values.NoeSchoole}
                                onChange={(r) => formik.setFieldValue("NoeSchoole", r)}
                                error={
                                    Boolean(formik.errors.NoeSchoole)
                                }
                                helperText={formik.errors.NoeSchoole}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"نوع مدرسه"}>
                                <option value={"غیرانتفاعی"}>غیرانتفاعی</option>
                                <option value={"دولتی"}>دولتی</option>


                            </MDSelect>
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="CodeMeli"
                                type={"number"}
                                name="CodeMeli"
                                value={formik.values.CodeMeli}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.CodeMeli)
                                }
                                helperText={formik.errors.CodeMeli}
                                autoComplete={"1"}
                                disabled={loading}
                                // width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"کد ملی"}/>
                        </Grid>

                    </>}
                    {activeStep === 4 && <>
                        <Grid item xs={12}>
                            <MDSelect
                                id="SathTahsilat"
                                name="SathTahsilat"
                                value={formik.values.SathTahsilat}
                                onChange={(r) => formik.setFieldValue("SathTahsilat", r)}
                                error={
                                    Boolean(formik.errors.SathTahsilat)
                                }
                                helperText={formik.errors.SathTahsilat}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"سطح تحصیلات"}>
                                <option value={"دبستانی"}>دبستانی</option>
                                <option value={" دوره متوسطه اول"}> دوره متوسطه اول</option>
                                <option value={" دوره متوسطه دوم"}> دوره متوسطه دوم</option>


                            </MDSelect>

                        </Grid>
                        <Grid item xs={12}>
                            <MDSelect
                                id="MaghTahsilat"
                                name="MaghTahsilat"
                                value={formik.values.MaghTahsilat}
                                onChange={(r) => formik.setFieldValue("MaghTahsilat", r)}
                                error={
                                    Boolean(formik.errors.MaghTahsilat)
                                }
                                helperText={formik.errors.MaghTahsilat}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"مقطع تحصیلات"}>
                                <option value={"پایه اول"}> پایه اول</option>
                                <option value={"پایه دوم"}>پایه دوم</option>
                                <option value={"پایه سوم"}>پایه سوم</option>
                                <option value={"پایه چهارم"}>پایه چهارم</option>
                                <option value={"پایه پنجم"}>پایه پنجم</option>
                                <option value={"پایه ششم"}>پایه ششم</option>
                                <option value={"پایه هفتم"}>پایه هفتم</option>
                                <option value={"پایه هشتم"}>پایه هشتم</option>
                                <option value={"پایه نهم"}>پایه نهم</option>
                                <option value={"پایه دهم"}>پایه دهم</option>
                                <option value={"پایه یازدهم"}>پایه یازدهم</option>
                                <option value={"پایه دوازدهم"}>پایه دوازدهم</option>


                            </MDSelect>

                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="NoeBime"
                                name="NoeBime"
                                value={formik.values.NoeBime}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.NoeBime)
                                }
                                helperText={formik.errors.NoeBime}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"نوع بیمه"}/>
                        </Grid>


                        <Grid item xs={12}>
                            <MDSelect
                                id="ParentStatus"
                                name="ParentStatus"
                                value={formik.values.ParentStatus}
                                onChange={(r) => formik.setFieldValue("ParentStatus", r)}
                                error={
                                    Boolean(formik.errors.ParentStatus)
                                }
                                helperText={formik.errors.ParentStatus}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"وضعیت زندگی والدین"}>
                                <option value={"مشترک"}>مشترک</option>
                                <option value={"متارکه"}>متارکه</option>


                            </MDSelect>
                        </Grid>

                        <Grid item xs={12}>
                            <MDInput
                                id="PayeThsili"
                                name="PayeThsili"
                                value={formik.values.PayeThsili}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.PayeThsili)
                                }
                                helperText={formik.errors.PayeThsili}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"پایه تحصیلی"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="CityTahsil"
                                name="CityTahsil"
                                value={formik.values.CityTahsil}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.CityTahsil)
                                }
                                helperText={formik.errors.CityTahsil}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"شهر محل تحصیل"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDSelect
                                id="TaradodMadrse"
                                name="TaradodMadrse"
                                value={formik.values.TaradodMadrse}
                                onChange={(r) => formik.setFieldValue("TaradodMadrse", r)}
                                error={
                                    Boolean(formik.errors.TaradodMadrse)
                                }
                                helperText={formik.errors.TaradodMadrse}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "100%",}}
                                label={"وضعیت تردد به مدرسه"}>
                                <option value={"پیاده روی"}>پیاده روی</option>
                                <option value={"سرویس مدرسه"}>سرویس مدرسه</option>
                                <option value={"وسیله شخصی"}>وسیله شخصی</option>
                                <option value={"حمل و نقل عمومی "}>حمل و نقل عمومی</option>


                            </MDSelect>

                        </Grid>
                    </>
                    }
                    {activeStep === 5 && <>
                        <Grid item xs={12}>
                            <MDDate
                                name="DateSchool"
                                onChange={(r) =>
                                    formik.setFieldValue("DateSchool", r)
                                }
                                defaultValue={formik.values.DateSchool}
                                label={("تاریخ ورود به مدرسه")}
                                error={
                                    Boolean(formik.errors.DateSchool)
                                }
                                portal
                                helperText={
                                    formik.errors.DateSchool
                                }
                                w={{xs: "100%", md: "100%", lg: "100%",}}

                                disabled={loading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="ShomSkoonat"
                                name="ShomSkoonat"
                                value={formik.values.ShomSkoonat}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.ShomSkoonat)
                                }
                                helperText={formik.errors.ShomSkoonat}
                                autoComplete={"1"}
                                disabled={loading}
                                type={"number"}

                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"شماره محل سکونت"}/>
                        </Grid>
                        <Grid item xs={12}>
                            <MDInput
                                id="AddressSkoonat"
                                name="AddressSkoonat"
                                value={formik.values.AddressSkoonat}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.AddressSkoonat)
                                }
                                helperText={formik.errors.AddressSkoonat}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                label={"آدرس محل سکونت"}/>
                        </Grid>
                    </>}
                    <Grid item xs={12} textAlign={"start"}>
                        <ButtonBase onClick={() => handleNextStep()}
                                    sx={{
                                        background: "#0BE1B1",
                                        width: "100%",
                                        borderRadius: "5px",
                                        height: 50
                                    }}
                                    disabled={loading}
                                    type={"button"}>
                            <MDBox width={"100%"} py={2}>
                                <MDTypography color={"black"} fontWeight={"bold"} fontSize={"20px"}>
                                    مرحله بعد
                                </MDTypography>
                            </MDBox>
                        </ButtonBase>

                    </Grid>
                </Grid>
            </MDBox>
            <MDBox sx={{
                width: "50%",
                justifySelf: "end",
                textAlign: "center"
            }}>
                <ButtonBase onClick={() => handleBazgasht()}
                            sx={{borderRadius: "5px", height: 50,}}
                            disabled={loading}
                            type={"button"}>
                    <MDTypography color={"black"} fontSize={"25px"} sx={{mr: 10}}>
                        بازگشت
                    </MDTypography>
                </ButtonBase>
            </MDBox>
            <MDBox sx={{
                py: 5,
                width: "100%",
                display: "flex",
                placeContent: "end",
                alignItems: "center",
                flexDirection: {xs: "column", md: "unset", xl: "unset"},
                position: {xs: "unset", md: "relative", xl: "relative"}
            }}>
                <MDBox component={"img"} src={CurrentUser().user.Sex === "F" ? FasdImage : MasdImage}
                       sx={{
                           height: {xs: "30vh", md: "30vh", xl: "30vh"},
                           position: {xs: "unset", md: "fixed", xl: "absolute"},
                           left: 0,
                           bottom: {xs: "unset", md: "0", xl: "55px"}
                       }}/>
                <MDBox sx={{width: "100%", border: "1px solid black", position: {xs: "relative", md: "absolute", xl: "absolute"},top:{xs: "20px", md: "unset", xl: "unset"}}}/>
                <Stepper nonLinear alternativeLabel activeStep={activeStep}
                         sx={{width: {xs: "100%", xl: "50%"}}}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepButton color="inherit" onClick={handleStep(index)}/>

                        </Step>
                    ))}
                </Stepper>
            </MDBox>
        </> : <>

            <Grid container direction={"column"} textAlign={"center"} sx={{py: "4rem"}}>
                <Grid item>
                    <MDTypography
                        sx={{color: "#005CB1", fontSize: "4rem", fontFamily: "vazir", fontWeight: "bold"}}>مرحله
                        تکمیل شد</MDTypography>
                </Grid>
                <Grid item>
                    <img src={CurrentUser().user.Sex === "F" ? FasdImage : MasdImage} style={{height: "60vh"}}/>
                </Grid>
                <Grid item>
                    <MDTypography
                        sx={{color: "#005CB1", fontSize: "4rem", fontFamily: "vazir", fontWeight: "bold"}}>آماده
                        ای برای مرحله بعد؟</MDTypography>

                </Grid>
                <Grid item>
                    <ButtonBase onClick={handleChangeMStep}
                                sx={{background: "#FF4D00", borderRadius: "5px", height: 50, py: 5, px: 10}}
                                disabled={loading}
                                type={"button"}>
                        <MDBox width={"100%"} py={2}>
                            <MDTypography color={"white"} fontWeight={"bold"} fontSize={"50px"}>
                                بزن بریم
                            </MDTypography>
                        </MDBox>
                    </ButtonBase>
                </Grid>
            </Grid>

        </>}

    </HeroLayout>
}